import React, { useState, useEffect, useRef, useCallback } from "react";
//import shipBg from "././assets/ship_image.jpg";
// ─────────────────────────────────────────────
// DUMMY SHIP PATH  (replace with real API data)
// Shape: { lat, lng, speed, heading, time }
// ─────────────────────────────────────────────
const DUMMY_SHIP_PATH = [
  { lat: 35.518, lng: -63.387, speed: 12.0, heading: 285, time: "2024-06-20 00:00" },
  { lat: 35.61,  lng: -64.20,  speed: 12.2, heading: 283, time: "2024-06-20 01:00" },
  { lat: 35.71,  lng: -65.05,  speed: 12.1, heading: 281, time: "2024-06-20 02:00" },
  { lat: 35.80,  lng: -65.92,  speed: 11.9, heading: 280, time: "2024-06-20 03:00" },
  { lat: 35.88,  lng: -66.80,  speed: 12.3, heading: 279, time: "2024-06-20 04:00" },
  { lat: 35.95,  lng: -67.70,  speed: 12.5, heading: 278, time: "2024-06-20 05:00" },
  { lat: 36.01,  lng: -68.62,  speed: 12.4, heading: 277, time: "2024-06-20 06:00" },
  { lat: 36.06,  lng: -69.55,  speed: 12.0, heading: 276, time: "2024-06-20 07:00" },
  { lat: 36.10,  lng: -70.49,  speed: 11.8, heading: 275, time: "2024-06-20 08:00" },
  { lat: 36.13,  lng: -71.44,  speed: 12.2, heading: 274, time: "2024-06-20 09:00" },
  { lat: 36.15,  lng: -72.40,  speed: 12.5, heading: 273, time: "2024-06-20 10:00" },
  { lat: 36.16,  lng: -73.37,  speed: 12.3, heading: 272, time: "2024-06-20 11:00" },
  { lat: 36.16,  lng: -74.35,  speed: 11.9, heading: 271, time: "2024-06-20 12:00" },
  { lat: 36.14,  lng: -75.33,  speed: 12.1, heading: 270, time: "2024-06-20 13:00" },
  { lat: 36.11,  lng: -76.31,  speed: 12.4, heading: 269, time: "2024-06-20 14:00" },
  { lat: 36.07,  lng: -77.29,  speed: 12.2, heading: 268, time: "2024-06-20 15:00" },
  { lat: 36.02,  lng: -78.27,  speed: 11.8, heading: 267, time: "2024-06-20 16:00" },
  { lat: 35.95,  lng: -79.24,  speed: 12.0, heading: 266, time: "2024-06-20 17:00" },
  { lat: 35.87,  lng: -80.20,  speed: 12.3, heading: 265, time: "2024-06-20 18:00" },
  { lat: 35.78,  lng: -81.15,  speed: 12.5, heading: 264, time: "2024-06-20 19:00" },
  { lat: 35.67,  lng: -82.09,  speed: 12.1, heading: 263, time: "2024-06-20 20:00" },
  { lat: 35.55,  lng: -83.01,  speed: 11.9, heading: 262, time: "2024-06-20 21:00" },
  { lat: 35.42,  lng: -83.91,  speed: 12.2, heading: 261, time: "2024-06-20 22:00" },
  { lat: 35.28,  lng: -84.79,  speed: 12.4, heading: 260, time: "2024-06-20 23:00" },
  { lat: 35.12,  lng: -85.65,  speed: 12.0, heading: 259, time: "2024-06-21 00:00" },
  { lat: 34.95,  lng: -86.49,  speed: 11.7, heading: 258, time: "2024-06-21 01:00" },
  { lat: 34.77,  lng: -87.31,  speed: 12.1, heading: 257, time: "2024-06-21 02:00" },
  { lat: 34.58,  lng: -88.11,  speed: 12.3, heading: 256, time: "2024-06-21 03:00" },
  { lat: 34.37,  lng: -88.89,  speed: 12.5, heading: 255, time: "2024-06-21 04:00" },
  { lat: 34.16,  lng: -89.65,  speed: 12.0, heading: 254, time: "2024-06-21 05:00" },
];

// ─────────────────────────────────────────────
// SHIP BG (replace import if using local image)
// ─────────────────────────────────────────────
 const shipBg = "/asset/ship_image.jpg"; 
   // placeholder image - replace with actual ship bg or map tiles as needed

// ─────────────────────────────────────────────
// INLINE STYLES  (no external CSS required)
// ─────────────────────────────────────────────
const S = {
  /* layout */
  page: {
    fontFamily: "'Segoe UI', sans-serif",
    background: "#f8fafc",
    minHeight: "100vh",
    padding: "0",
  },
  dashboard: {
    width: "100%",
    background: "#fff",
    borderRadius: 12,
    overflow: "hidden",
    border: "0.5px solid #e2e8f0",
    boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
  },

  /* nav */
  nav: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    borderBottom: "0.5px solid #e2e8f0",
    background: "#fff",
    flexWrap: "wrap",
    gap: 8,
  },
  navTabs: { display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" },
  vesselPill: {
    background: "#1e40af",
    color: "#fff",
    border: "none",
    borderRadius: 20,
    padding: "5px 14px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  },
  tab: {
    background: "transparent",
    border: "0.5px solid #e2e8f0",
    borderRadius: 8,
    padding: "5px 12px",
    fontSize: 12,
    cursor: "pointer",
    color: "#64748b",
    position: "relative",
  },
  tabActive: {
    background: "#f1f5f9",
    color: "#1e293b",
    borderColor: "#cbd5e1",
  },
  badge: {
    background: "#ef4444",
    color: "#fff",
    borderRadius: 10,
    fontSize: 10,
    padding: "1px 5px",
    position: "absolute",
    top: -5,
    right: -5,
  },
  navRight: { display: "flex", gap: 20, alignItems: "center" },
  navStat: { display: "flex", flexDirection: "column" },
  navStatLbl: {
    fontSize: 10,
    color: "#94a3b8",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  navStatVal: { fontSize: 12, fontWeight: 500, color: "#1e293b" },
  onlineDot: {
    display: "inline-block",
    width: 7,
    height: 7,
    background: "#16a34a",
    borderRadius: "50%",
    marginRight: 4,
  },

  /* body */
  body: { display: "flex", minHeight: 520 },
  leftPane: {
    flex: 1,
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    overflow: "hidden",
    transition: "all 0.35s",
  },
  mapPane: { flex: 1, position: "relative", overflow: "hidden" },

  /* chip bar */
  chipBar: {
    position: "absolute",
    top: 14,
    left: 14,
    right: 60,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    background: "rgb(0 67 71 / 37%",
    borderRadius: 12,
    padding: "9px 16px",
    gap: 0,
    width: "fit-content",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  chipItem: (isLast) => ({
    display: "flex",
    flexDirection: "column",
    paddingRight: isLast ? 0 : 14,
    marginRight: isLast ? 0 : 14,
    borderRight: isLast ? "none" : "0.5px solid #e2e8f0",
    whiteSpace: "nowrap",
  }),
  chipLbl: {
    fontSize: 10,
    color: "#94a3b8",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 1,
  },

  /* weather row */
   weatherRow: {
     position: "absolute",
  top: 8,
    left: 554,
    right: 10,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    // background: "rgba(255,255,255,0.93)",
    borderRadius: 12,
    padding: "8px 9px",
    gap: 0,
    width: "fit-content",
    // boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  wxBar: {
    display: "flex",
    alignItems: "center",
    background: "rgb(0 67 71 / 37%",
    borderRadius: 12,
    padding: "9px 14px",
    gap: 0,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  wxItem: (isLast) => ({
    display: "flex",
    alignItems: "center",
    gap: 9,
    paddingRight: isLast ? 0 : 14,
    marginRight: isLast ? 0 : 14,
    borderRight: isLast ? "none" : "0.5px solid #e2e8f0",
  }),
  wxIcon: {
    width: 30,
    height: 30,
    borderRadius: 7,
    background: "#e0f0ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },

  /* crew bar */
  crewBar: {
    position: "absolute",
    bottom: 10,
    left: 8,
    right: 8,
    borderRadius:8,
    background: "rgba(255,255,255,0.94)",
    borderTop: "0.5px solid #e2e8f0",
    padding: "6px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    zIndex: 10,
  },
  crewLeft: { display: "flex", alignItems: "center", gap: 10 },
  crewAvatar: {
    width: 32,
    height: 32,
    background: "#dbeafe",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
  },

  /* toggle button */
  toggleBtn: {
    position: "absolute",
    top: 74,
    right: 18,
    zIndex: 20,
    background: "rgb(0 67 71 / 37%",
    border: "0.5px solid rgb(0 67 71 / 37%",
    borderRadius: 8,
    padding: "6px 12px",
    fontSize: 12,
    fontWeight: 500,
    cursor: "pointer",
    color: "#ffffff",
    display: "flex",
    alignItems: "center",
    gap: 6,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  },

  /* right panel */
  panel: {
    width: 280,
    borderLeft: "0.5px solid #e2e8f0",
    overflowY: "auto",
    background: "#fff",
  },
  section: { borderBottom: "0.5px solid #e2e8f0", padding: "10px 12px" },
  secHdr: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  secTitle: {
    fontSize: 11,
    fontWeight: 600,
    color: "#64748b",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    display: "flex",
    alignItems: "center",
    gap: 5,
  },
  opGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 6,
    marginTop: 8,
  },
  card: {
    background: "#f8fafc",
    borderRadius: 8,
    padding: "7px 10px",
    border: "0.5px solid #e2e8f0",
  },
  cardLbl: {
    fontSize: 10,
    color: "#94a3b8",
    display: "block",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 2,
  },
  perfGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: 5,
  },
  auxGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 5 },
  svcRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 0",
    borderBottom: "0.5px solid #f1f5f9",
  },
  rptBtn: {
    fontSize: 11,
    background: "transparent",
    border: "0.5px solid #cbd5e1",
    borderRadius: 6,
    padding: "3px 8px",
    cursor: "pointer",
    color: "#64748b",
  },
  faultGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 6,
    marginTop: 8,
  },

  /* playback bar */
  playbackBar: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(255,255,255,0.97)",
    borderTop: "0.5px solid #e2e8f0",
    padding: "8px 14px",
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  pbBtn: {
    width: 30,
    height: 30,
    borderRadius: 6,
    border: "0.5px solid #cbd5e1",
    background: "#fff",
    cursor: "pointer",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  pbSlider: { flex: 1 },
  pbInfo: {
    fontSize: 11,
    color: "#64748b",
    whiteSpace: "nowrap",
    flexShrink: 0,
    minWidth: 100,
    textAlign: "right",
  },
  pbSpeed: {
    fontSize: 11,
    background: "#eff6ff",
    border: "0.5px solid #bfdbfe",
    borderRadius: 5,
    padding: "2px 8px",
    color: "#1e40af",
    cursor: "pointer",
    flexShrink: 0,
  },
  mapCtrl: {
    position: "absolute",
    top: 14,
    right: 60,
    zIndex: 20,
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  mapCtrlBtn: {
    width: 30,
    height: 30,
    borderRadius: 7,
    border: "0.5px solid #cbd5e1",
    background: "",
    cursor: "pointer",
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
  },
};

// ─────────────────────────────────────────────
// MAP CANVAS  sub-component
// ─────────────────────────────────────────────
function MapCanvas({ shipPath, playIdx, scale }) {
  const canvasRef = useRef(null);

  const getPathBounds = useCallback(() => {
    let minLat = Infinity, maxLat = -Infinity, minLng = Infinity, maxLng = -Infinity;
    shipPath.forEach((p) => {
      if (p.lat < minLat) minLat = p.lat;
      if (p.lat > maxLat) maxLat = p.lat;
      if (p.lng < minLng) minLng = p.lng;
      if (p.lng > maxLng) maxLng = p.lng;
    });
    const dLat = maxLat - minLat || 1;
    const dLng = maxLng - minLng || 1;
    return {
      minLat: minLat - dLat * 0.18,
      maxLat: maxLat + dLat * 0.18,
      minLng: minLng - dLng * 0.18,
      maxLng: maxLng + dLng * 0.18,
    };
  }, [shipPath]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const parent = canvas.parentElement;
    const W = parent.clientWidth || 520;
    const H = (parent.clientHeight || 500) - 48; // subtract playback bar
    canvas.width = W;
    canvas.height = H;
    const ctx = canvas.getContext("2d");

    const bounds = getPathBounds();

    const toPixel = (lat, lng) => {
      const padX = W * 0.1,  padY = H * 0.12;
      const usableW = (W - 2 * padX) * scale;
      const usableH = (H - 2 * padY) * scale;
      const x = padX + ((lng - bounds.minLng) / (bounds.maxLng - bounds.minLng)) * usableW;
      const y = padY + (1 - (lat - bounds.minLat) / (bounds.maxLat - bounds.minLat)) * usableH;
      return { x, y };
    };

    // bg ocean
    ctx.fillStyle = "#dbeafe";
    ctx.fillRect(0, 0, W, H);

    // subtle grid
    ctx.strokeStyle = "rgba(148,163,184,0.22)";
    ctx.lineWidth = 0.5;
    for (let i = 0; i <= 10; i++) {
      ctx.beginPath(); ctx.moveTo((W / 10) * i, 0); ctx.lineTo((W / 10) * i, H); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(0, (H / 8) * i); ctx.lineTo(W, (H / 8) * i); ctx.stroke();
    }

    // full route (dashed gray)
    if (shipPath.length > 1) {
      ctx.beginPath();
      ctx.strokeStyle = "rgba(100,116,139,0.35)";
      ctx.lineWidth = 1.5;
      ctx.setLineDash([5, 4]);
      const p0 = toPixel(shipPath[0].lat, shipPath[0].lng);
      ctx.moveTo(p0.x, p0.y);
      shipPath.forEach((p) => { const px = toPixel(p.lat, p.lng); ctx.lineTo(px.x, px.y); });
      ctx.stroke();
      ctx.setLineDash([]);
    }

    // traveled path (solid blue)
    if (playIdx > 0) {
      ctx.beginPath();
      ctx.strokeStyle = "#2563eb";
      ctx.lineWidth = 2.5;
      const p0 = toPixel(shipPath[0].lat, shipPath[0].lng);
      ctx.moveTo(p0.x, p0.y);
      for (let i = 1; i <= playIdx; i++) {
        const px = toPixel(shipPath[i].lat, shipPath[i].lng);
        ctx.lineTo(px.x, px.y);
      }
      ctx.stroke();
    }

    // waypoint dots
    shipPath.forEach((p, i) => {
      const px = toPixel(p.lat, p.lng);
      ctx.beginPath();
      ctx.arc(px.x, px.y, i === playIdx ? 7 : 3.5, 0, Math.PI * 2);
      ctx.fillStyle =
        i < playIdx ? "#93c5fd" : i === playIdx ? "#1d4ed8" : "rgba(100,116,139,0.25)";
      ctx.fill();
      if (i === playIdx) {
        ctx.strokeStyle = "#fff"; ctx.lineWidth = 2; ctx.stroke();
      }
    });

    // Origin / Dest labels
    const orig = toPixel(shipPath[0].lat, shipPath[0].lng);
    const dest = toPixel(shipPath[shipPath.length - 1].lat, shipPath[shipPath.length - 1].lng);
    ctx.font = "bold 10px 'Segoe UI', sans-serif";
    ctx.fillStyle = "#1e40af";
    ctx.fillText("Origin", orig.x + 10, orig.y - 5);
    ctx.fillText("Dest", dest.x + 10, dest.y - 5);

    // Ship icon at current index
    const cur = shipPath[playIdx];
    const cp = toPixel(cur.lat, cur.lng);
    drawShipIcon(ctx, cp.x, cp.y, cur.heading || 270);

    // Info bubble
    const infoText = `${cur.lat.toFixed(3)}, ${cur.lng.toFixed(3)}`;
    const speedText = `${cur.speed} kn  •  ${cur.heading}°`;
    const tw = Math.max(ctx.measureText(infoText).width, ctx.measureText(speedText).width);
    const bx = cp.x + 16, by = cp.y - 30, bw = tw + 18, bh = 36;
    ctx.fillStyle = "rgba(255,255,255,0.96)";
    ctx.strokeStyle = "#bfdbfe"; ctx.lineWidth = 1;
    roundRect(ctx, bx, by, bw, bh, 7);
    ctx.fill(); ctx.stroke();
    ctx.fillStyle = "#1e293b"; ctx.font = "bold 11px 'Segoe UI', sans-serif";
    ctx.fillText(infoText, bx + 9, by + 14);
    ctx.fillStyle = "#64748b"; ctx.font = "10px 'Segoe UI', sans-serif";
    ctx.fillText(speedText, bx + 9, by + 28);

  }, [shipPath, playIdx, scale, getPathBounds]);

  return (
    <canvas
      ref={canvasRef}
      style={{ display: "block", width: "100%", height: "calc(100% - 48px)" }}
    />
  );
}

function drawShipIcon(ctx, x, y, heading) {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(((heading - 270) * Math.PI) / 180);
  ctx.fillStyle = "#1d4ed8";
  ctx.beginPath();
  ctx.moveTo(0, -12); ctx.lineTo(7, 8); ctx.lineTo(0, 4); ctx.lineTo(-7, 8);
  ctx.closePath();
  ctx.fill();
  ctx.strokeStyle = "#fff"; ctx.lineWidth = 1.5; ctx.stroke();
  ctx.restore();
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y); ctx.quadraticCurveTo(x + w, y, x + w, y + r);
  ctx.lineTo(x + w, y + h - r); ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
  ctx.lineTo(x + r, y + h); ctx.quadraticCurveTo(x, y + h, x, y + h - r);
  ctx.lineTo(x, y + r); ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

// ─────────────────────────────────────────────
// SECTION  (collapsible right-panel block)
// ─────────────────────────────────────────────
function Section({ icon, title, children }) {
  const [open, setOpen] = useState(true);
  return (
    <div style={S.section}>
      <div style={S.secHdr} onClick={() => setOpen((v) => !v)}>
        <span style={S.secTitle}>{icon} {title}</span>
        <span style={{ fontSize: 10, color: "#94a3b8", transform: open ? "" : "rotate(180deg)", transition: "transform 0.2s" }}>▲</span>
      </div>
      {open && <div style={{ marginTop: 8 }}>{children}</div>}
    </div>
  );
}

// ─────────────────────────────────────────────
// MAIN  COMPONENT
// ─────────────────────────────────────────────
export default function VesselDashboard() {
  // ── state ──
  const [activeTab, setActiveTab] = useState("Map");
  const [showMap, setShowMap]   = useState(false);

  // playback
  const [playIdx,  setPlayIdx]  = useState(0);
  const [playing,  setPlaying]  = useState(false);
  const [speedIdx, setSpeedIdx] = useState(0);
  const [mapScale, setMapScale] = useState(1);
  const timerRef = useRef(null);
  const SPEEDS = [1, 2, 4, 8];
  const SPEED_LABELS = ["1x", "2x", "4x", "8x"];

  // UTC clock
  const [utc, setUtc] = useState("--:--:--");
  useEffect(() => {
    const tick = () => {
      const n = new Date();
      setUtc(
        [n.getUTCHours(), n.getUTCMinutes(), n.getUTCSeconds()]
          .map((v) => String(v).padStart(2, "0"))
          .join(":")
      );
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  // ── playback helpers ──
  const stopTimer = () => { clearInterval(timerRef.current); timerRef.current = null; };

  const startPlay = useCallback(() => {
    if (playIdx >= DUMMY_SHIP_PATH.length - 1) setPlayIdx(0);
    setPlaying(true);
    timerRef.current = setInterval(() => {
      setPlayIdx((prev) => {
        if (prev >= DUMMY_SHIP_PATH.length - 1) {
          stopTimer();
          setPlaying(false);
          return prev;
        }
        return prev + 1;
      });
    }, Math.round(600 / SPEEDS[speedIdx]));
  }, [playIdx, speedIdx]);

  const pausePlay = () => { stopTimer(); setPlaying(false); };
  const togglePlay = () => { playing ? pausePlay() : startPlay(); };
  const restartPlayback = () => { pausePlay(); setPlayIdx(0); };
  const sliderSeek = (val) => { pausePlay(); setPlayIdx(Number(val)); };
  const cycleSpeed = () => {
    const next = (speedIdx + 1) % SPEEDS.length;
    setSpeedIdx(next);
    if (playing) { stopTimer(); setPlaying(false); }
  };

  // cleanup on unmount
  useEffect(() => () => stopTimer(), []);

  const curPoint = DUMMY_SHIP_PATH[playIdx];

  // ── chips data ──
  const chips = [
    { label: "SOG",       value: "12",   unit: "Kn",  color: "#1e293b" },
    { label: "STW",       value: "12.5", unit: "Kn",  color: "#1e293b" },
    { label: "Condition", value: "Sailing",            color: "#16a34a" },
    { label: "Draft Fwd", value: "5.6 m",              color: "#2563eb" },
    { label: "Draft Aft", value: "5.4 m",              color: "#2563eb" },
  ];

  const tabs = ["Map", "Crew", "Reports", "Alerts"];

  return (
<React.Fragment>
    <div className="page-content">


    <div style={S.page}>
      <div style={S.dashboard}>

        {/* ── NAV ── */}
        <header style={S.nav}>
          <div style={S.navTabs}>
            <button style={S.vesselPill}>🚢 MV Atlas Prime ▾</button>
            {tabs.map((t) => (
              <button
                key={t}
                style={activeTab === t ? { ...S.tab, ...S.tabActive } : S.tab}
                onClick={() => setActiveTab(t)}
              >
                {t === "Map" && "🗺 "}
                {t === "Crew" && "👥 "}
                {t === "Reports" && "📋 "}
                {t === "Alerts" && "🔔 "}
                {t}
                {t === "Alerts" && <span style={S.badge}>3</span>}
              </button>
            ))}
          </div>
          <div style={S.navRight}>
            <div style={S.navStat}>
              <span style={S.navStatLbl}>System Status</span>
              <span style={{ ...S.navStatVal, color: "#16a34a" }}>
                <span style={S.onlineDot} />Online
              </span>
            </div>
            <div style={S.navStat}>
              <span style={S.navStatLbl}>Time UTC</span>
              <span style={S.navStatVal}>{utc}</span>
            </div>
          </div>
        </header>

        {/* ── BODY ── */}
        <div style={S.body}>

          {/* ── LEFT / MAP PANE ── */}
          {!showMap ? (
            /* SHIP PHOTO */
            <div
              style={{
                ...S.leftPane,
                backgroundImage: `url(${shipBg})`,
              }}
            >
              {/* chip bar */}
              <div style={S.chipBar}>
                {chips.map((c, i) => (
                  <div key={i} style={S.chipItem(i === chips.length - 1)}>
                    <span style={S.chipLbl}>{c.label}</span>
                    <span style={{ fontSize: c.unit ? 17 : 13, fontWeight: 500, color: c.color }}>
                      {c.value}
                      {c.unit && <small style={{ fontSize: 11, color: "#94a3b8", marginLeft: 2 }}>{c.unit}</small>}
                    </span>
                  </div>
                ))}
              </div>
   {/* weather row */}
              <div style={S.weatherRow}>
                <div style={S.wxBar}>
                  <div style={S.wxItem(false)}>
                    <div style={S.wxIcon}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                        <circle cx="12" cy="12" r="5"/>
                        <line x1="12" y1="1" x2="12" y2="3"/>
                        <line x1="12" y1="21" x2="12" y2="23"/>
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                        <line x1="1" y1="12" x2="3" y2="12"/>
                        <line x1="21" y1="12" x2="23" y2="12"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: "#94a3b8" }}>Weather</div>
                      <div style={{ fontSize: 12, fontWeight: 500, color: "#1e293b" }}>6 kts NE — Stable</div>
                    </div>
                  </div>
                  <div style={S.wxItem(true)}>
                    <div style={S.wxIcon}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
                        <circle cx="12" cy="10" r="3"/>
                      </svg>
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: "#94a3b8" }}>Lat: {curPoint.lat.toFixed(3)}</div>
                      <div style={{ fontSize: 12, fontWeight: 500, color: "#1e293b" }}>Lng: {curPoint.lng.toFixed(3)}</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* toggle button */}
              <button style={S.toggleBtn} onClick={() => setShowMap(true)}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                  <polygon points="3,11 3,22 9,18 15,22 21,18 21,7 15,11 9,7"/>
                  <line x1="9" y1="7" x2="9" y2="18"/>
                  <line x1="15" y1="11" x2="15" y2="22"/>
                </svg>
                Show Map
              </button>

           

              {/* crew bar */}
              <div style={S.crewBar}>
                <div style={S.crewLeft}>
                  <div style={S.crewAvatar}>👤</div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 500, color: "#1e293b" }}>Assigned Crew: 3</div>
                    <div style={{ fontSize: 11, color: "#64748b" }}>Alice Chen, Bob Martin, Stefen</div>
                  </div>
                </div>
                <button
                  style={{
                    width: 28, height: 28, borderRadius: "50%",
                    background: "#2563eb", color: "#fff", border: "none",
                    fontSize: 18, cursor: "pointer",
                  }}
                >
                  +
                </button>
              </div>
            </div>
          ) : (
            /* MAP PANE */
            <div style={{ ...S.mapPane, background: "#dbeafe" }}>
              <MapCanvas
                shipPath={DUMMY_SHIP_PATH}
                playIdx={playIdx}
                scale={mapScale}
              />

              {/* toggle back button */}
              <button style={{ ...S.toggleBtn, top: 14, right: 60 }} onClick={() => setShowMap(false)}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2">
                  <rect x="2" y="3" width="20" height="14" rx="2"/>
                  <line x1="8" y1="21" x2="16" y2="21"/>
                  <line x1="12" y1="17" x2="12" y2="21"/>
                </svg>
                Show Ship
              </button>

              {/* zoom controls */}
              <div style={S.mapCtrl}>
                <button style={S.mapCtrlBtn} onClick={() => setMapScale((s) => Math.min(2.5, +(s + 0.25).toFixed(2)))}>+</button>
                <button style={S.mapCtrlBtn} onClick={() => setMapScale((s) => Math.max(0.4, +(s - 0.25).toFixed(2)))}>−</button>
              </div>

              {/* PLAYBACK BAR */}
              <div style={S.playbackBar}>
                <button style={S.pbBtn} onClick={togglePlay}>
                  {playing ? "⏸" : "▶"}
                </button>
                <button
                  style={S.pbBtn}
                  onClick={restartPlayback}
                  disabled={playIdx === 0 && !playing}
                >
                  ↺
                </button>
                <input
                  type="range"
                  style={S.pbSlider}
                  min={0}
                  max={DUMMY_SHIP_PATH.length - 1}
                  value={playIdx}
                  step={1}
                  onChange={(e) => sliderSeek(e.target.value)}
                />
                <span style={S.pbInfo}>
                  {playIdx + 1}/{DUMMY_SHIP_PATH.length} · {curPoint.time.slice(11)}
                </span>
                <button style={S.pbSpeed} onClick={cycleSpeed}>
                  {SPEED_LABELS[speedIdx]}
                </button>
              </div>
            </div>
          )}

          {/* ── RIGHT PANEL ── */}
          <aside style={S.panel}>

            <Section icon="⚙" title="Operational Status">
              <div style={S.opGrid}>
                {[["SOG","12 Kn"],["STW","12.5 Kn"],["Draft Fwd","5.6 m"],["Draft Aft","5.4 m"]].map(([l,v]) => (
                  <div key={l} style={S.card}>
                    <span style={S.cardLbl}>{l}</span>
                    <span style={{ fontSize: 14, fontWeight: 500, color: "#1e293b" }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginTop:6, background:"#f8fafc", borderRadius:8, padding:"6px 10px", border:"0.5px solid #e2e8f0" }}>
                <span style={S.cardLbl}>Condition</span>
                <span style={{ fontSize:13, fontWeight:500, color:"#16a34a" }}>Sailing</span>
              </div>
            </Section>

            <Section icon="⚡" title="Live Performance">
              <div style={{ fontSize:10, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.04em", marginBottom:4 }}>Main Engine</div>
              <div style={S.perfGrid}>
                {[["Power","11500 KW","#2563eb"],["RPM","57","#2563eb"],["Load","48.5%","#2563eb"]].map(([l,v,c]) => (
                  <div key={l} style={S.card}>
                    <span style={S.cardLbl}>{l}</span>
                    <span style={{ fontSize:13, fontWeight:500, color:c }}>{v}</span>
                  </div>
                ))}
              </div>
              <div style={{ fontSize:10, color:"#94a3b8", textTransform:"uppercase", letterSpacing:"0.04em", marginTop:8, marginBottom:4 }}>Auxiliary Engine</div>
              <div style={S.auxGrid}>
                {[["AE 1","640 KW",true],["AE 2","0 KW",false],["AE 3","515 KW",true],["AE 4","0 KW",false]].map(([l,v,on]) => (
                  <div key={l} style={S.card}>
                    <span style={S.cardLbl}>{l}</span>
                    <span style={{ fontSize:13, fontWeight:500, color: on ? "#16a34a" : "#94a3b8" }}>{v}</span>
                  </div>
                ))}
              </div>
            </Section>

            <Section icon="🔧" title="Service History">
              {[
                ["Minor blade repair",    "20/12/2023"],
                ["Routine inspection",    "24/11/2023"],
                ["Sensor recalibration",  "20/12/2023"],
              ].map(([name, date]) => (
                <div key={name} style={S.svcRow}>
                  <div>
                    <span style={{ fontSize:12, color:"#1e293b" }}>{name}</span>
                    <span style={{ fontSize:11, color:"#94a3b8" }}> – {date}</span>
                  </div>
                  <button style={S.rptBtn}>≡ Report</button>
                </div>
              ))}
            </Section>

            <Section icon="⚠" title="Fault Summary">
              <div style={S.faultGrid}>
                <div style={S.card}>
                  <span style={S.cardLbl}>MTTR (avg)</span>
                  <span style={{ fontSize:14, fontWeight:500, color:"#b45309" }}>2.1 h</span>
                </div>
                <div style={S.card}>
                  <span style={S.cardLbl}>Type</span>
                  <span style={{ fontSize:11, fontWeight:500, color:"#b45309" }}>Temp – Nacelle</span>
                </div>
              </div>
            </Section>

          </aside>
        </div>
      </div>
    </div>
    </div>
    </React.Fragment>
  );
}